import { createContext } from "react";

export const HeadingContext = createContext({ level: 1 });